import { PermissionRole } from '../models';

export default class PermissionsHandler {
  constructor(permissionsList) {
    this.permissions = [];
    if (permissionsList != null && permissionsList.length) {
      this.permissions = permissionsList.map((permission) => new PermissionRole(permission));
    }

    this.accessLevelRestrictionIndex = { None: 0, View: 1, Modify: 2 };
  }

  hasAuth(code, level) {
    if (typeof code !== 'string' || code.trim() === '') {
      return false;
    }

    const permission = this.permissions.find((perm) => perm.authCode === code);
    let result = false;
    if (permission != null) {
      const permissionAccessLevel = this.accessLevelRestrictionIndex[permission.accessLevel];
      const requestedAccessLevel = this.accessLevelRestrictionIndex[level];
      result = requestedAccessLevel <= permissionAccessLevel;
    }
    return result;
  }
}
